import React from 'react'
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import s from './CancellationPolicies.css';

// Locale
import messages from '../../locale/jsonMessages';
class Flexible extends React.Component {

  static propTypes = {
    siteName: PropTypes.string.isRequired
  };

  render() {
    const { policyData } = this.props;
    return (
      <div className={s.spaceTop3}>
        <p className={cx(s.commonContentText, s.spaceBottom4)}>{policyData?.policyContent}</p>
        <p className={cx(s.commonContentText, s.spaceBottom4)}>{policyData?.subTitle}</p>
        <div>
          <div className={cx(s.cancelCard, s.cancelCardOne, s.spaceBottom3)}>
            <h4 className={cx(s.commonContentText, s.fontWeightMedium, s.spaceBottom3)}><FormattedMessage {...messages.flexibleBeforeOneDay} /></h4>
            <p className={cx(s.commonContentText)}>{policyData?.content1}</p>
          </div>
          <div className={cx(s.cancelCard, s.cancelCardTwo, s.spaceBottom3)}>
            <h4 className={cx(s.commonContentText, s.fontWeightMedium, s.spaceBottom3)}><FormattedMessage {...messages.cancellationCheckIn} /></h4>
            <p className={cx(s.commonContentText)}>{policyData?.content2}</p>
          </div>
          <div className={cx(s.cancelCard, s.cancelCardThree)}>
            <h4 className={cx(s.commonContentText, s.fontWeightMedium, s.spaceBottom3)}><FormattedMessage {...messages.cancellationCheckOut} /></h4>
            <p className={cx(s.commonContentText)}>{policyData?.content3}</p>
          </div>
        </div>
        <hr className={s.horizontalLine} />
        <div className={s.cancelDescSec}>
          <h4 className={cx(s.commonContentText, s.fontWeightMedium, s.spaceBottom3)}> <FormattedMessage {...messages.cancellationDescription} /></h4>
          <ul className={cx(s.descListSpaceLeft, 'descListSpaceRightRTL')}>
            {policyData?.subContent?.split('\n').map((item, index) => (
              <li key={index} className={cx(s.commonContentText, s.spaceBottom3)}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}
export default injectIntl(withStyles(s)(Flexible));
